import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

interface CheckboxFieldProps extends Omit<CheckboxProps, 'name' | 'onChange' | 'checked' | 'inputProps'> {
	input: {
		checked?: boolean;
		name?: string;
		onChange?: CheckboxProps['onChange'];
		[key: string]: any;
	};
	meta?: any;
}

const CheckboxField = ({input: {checked, name, onChange, ...restInput}, meta, ...rest}: CheckboxFieldProps) => (
	<Checkbox
		{...rest}
		name={name}
		inputProps={restInput}
		onChange={onChange}
		checked={checked}
	/>
);
export default CheckboxField;
